import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import ClearIcon from "@material-ui/icons/Clear";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import {handleConcursosDetailError} from "../../utils/errors";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    tooltip: {
        fontSize: "14px",
        fontWeight: "normal",
    },
}));

const DeclineModal = (props) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [comment, setComment] = React.useState("");
    const [openSpinner, setOpenSpinner] = React.useState(false);

    const handleOpen = () => {
        setOpen(!open);
    };

    const handleChange = (event) => {
        setComment(event.target.value);
    };

    const handleError = (error) => {
        setOpen(false);
        setOpenSpinner(false);
        handleConcursosDetailError(error)
    }

    const handleClick = () => {
        setOpenSpinner(true);
        axios
            .post(
                window.ENV.API_URL + "/concursosRevision/" + props.concursoId + "/",
                {
                    status: "rechazado",
                    comentario: comment,
                }
            )
            .then((res) => window.location.reload())
            .catch((error) => handleError(error));
    };

    return (
        <Fragment>
            {/*
      <Button color="secondary" onClick={handleOpen}>
        {props.label}
      </Button>*/}
            <Tooltip
                onClick={handleOpen}
                title={<span className={classes.tooltip}>{props.label}</span>}
            >
                <IconButton>
                    <ClearIcon/>
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleOpen} scroll={"paper"} fullWidth>
                <DialogTitle>Rechazar concurso</DialogTitle>
                <DialogContent dividers={true}>
                    <p className="text-center">
                        Escriba el motivo para rechazar el concurso{" "}
                        <strong>{props.name}</strong>
                    </p>

                    <TextField
                        label="Motivo"
                        multiline
                        fullWidth
                        rowsMax={6}
                        value={comment}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        style={{boxShadow: "none"}}
                        variant="contained"
                        onClick={handleOpen}
                    >
                        Cancelar
                    </Button>
                    <Button
                        style={{boxShadow: "none"}}
                        color="secondary"
                        variant="contained"
                        onClick={handleClick}
                    >
                        Rechazar
                    </Button>
                </DialogActions>
                <Backdrop className={classes.backdrop} open={openSpinner}>
                    <CircularProgress color="inherit"/>
                </Backdrop>
            </Dialog>
        </Fragment>
    );
};

export default DeclineModal;
